<homey-lotteries-dialog-content
  [singleDescription]="autoApplying() ? 'This lottery doesn\'t match your Auto-Apply preferences, but you can still apply manually.<br>Update your Auto-Apply settings anytime in the Applications tab.' : 'You\'re eligible for a new lottery.'"
  [multipleDescription]="autoApplying() ? 'These lotteries don\'t match your Auto-Apply preferences, but you can still apply manually.<br>Update your Auto-Apply settings anytime in the Applications tab.' : 'You\'re eligible for new lotteries.'"
  singleTitle="New eligible lottery!"
  multipleTitle="New eligible lotteries!"
  [closeButton]="closeButton()"
  [notification]="data()"
>
  <ng-template lotteryDialogListItem let-lottery>
    <homey-open-lottery-list-item [noNegativeMargin]="true" [openInPopup]="true" [lottery]="lottery"></homey-open-lottery-list-item>
  </ng-template>
</homey-lotteries-dialog-content>
